module.exports = __webpack_public_path__ + "static/img/MKD-logo2.b9a716e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MKD-logo2.jpg
// module id = 196
// module chunks = 169